import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { WebsiteConfigFormOpeningHoursComponent } from './website-config-form-opening-hours/website-config-form-opening-hours.component';
import { WebsiteConfigFormStylingComponent } from './website-config-form-styling/website-config-form-styling.component';
import { WebsiteConfigFormAppManagementComponent } from './website-config-form-app-management/website-config-form-app-management.component';
import { WebsiteConfigFormContactDataComponent } from './website-config-form-contact-data/website-config-form-contact-data.component';
import { WebsiteConfigFormLegalNoticeComponent } from './website-config-form-legal-notice/website-config-form-legal-notice.component';
import { WebsiteConfigFormPageAdministrationComponent } from './website-config-form-page-administration/website-config-form-page-administration.component';
import { WebsiteConfigReviewsComponent } from './website-config-reviews/website-config-reviews.component';
import { StripePricingTableComponent } from '../../../../admin/pages/pricing-table/stripe-pricing-table/stripe-pricing-table.component';
import { WebsiteConfigFormPartnerComponent } from './website-config-form-partner/website-config-form-partner.component';
import { WebsiteConfigFormSocialMediaComponent } from './website-config-form-social-media/website-config-form-social-media.component';
import { WidgetQuickActionComponent } from "./widget-quick-action/widget-quick-action.component";
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-website-config-form',
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    WebsiteConfigFormOpeningHoursComponent,
    WebsiteConfigFormStylingComponent,
    WebsiteConfigFormAppManagementComponent,
    WebsiteConfigFormContactDataComponent,
    WebsiteConfigFormLegalNoticeComponent,
    WebsiteConfigFormPageAdministrationComponent,
    WebsiteConfigFormPartnerComponent,
    WebsiteConfigFormSocialMediaComponent,
    WebsiteConfigReviewsComponent,
    StripePricingTableComponent,
    WebsiteConfigFormSocialMediaComponent,
    WidgetQuickActionComponent
],
  templateUrl: './website-config-form.component.html',
  styleUrl: './website-config-form.component.scss',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: []
})
export class WebsiteConfigFormComponent {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private websiteState: WebsiteStateService,
    public dialogRef: MatDialogRef<WebsiteConfigFormComponent>) { }

  ngOnInit(): void {
  }

  public onTabChanged(event: any) {
    if (!isPlatformBrowser(this.platformId)) return;
    const color = event.tab.ariaLabel === 'Stripe' ? '#6aa84f' : null;
    document.documentElement.style.setProperty('--mdc-tab-indicator-active-indicator-color', color);
    document.documentElement.style.setProperty('--mat-tab-header-active-focus-indicator-color', color);
    document.documentElement.style.setProperty('--mat-tab-header-active-hover-indicator-color', color);
  }

  // ### DIALOG ACTIONS ###
  public cancel() {
    this.websiteState.discardChanges();
    this.dialogRef.close();
  }

  public saveChanges() {
    this.dialogRef.close();
  }

}